import { render, staticRenderFns } from "./EventSummaryHeader.vue?vue&type=template&id=dd91ea34&scoped=true&"
import script from "./EventSummaryHeader.vue?vue&type=script&lang=ts&"
export * from "./EventSummaryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EventSummaryHeader.vue?vue&type=style&index=0&id=dd91ea34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd91ea34",
  null
  
)

export default component.exports